module.exports = __webpack_public_path__ + "static/media/diengioDetail.5a720cd9.png";